import { useContext, useRef, useState, useEffect } from "react";
import { Button, Nav, Offcanvas } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import "../styles/AdminSidebar.css";
import { FaBuilding } from "react-icons/fa";
import companyLogo from "../assets/logo.png";
import { TbLogout } from "react-icons/tb";

export default function AdminSidebar({
  sidebarOpen,
  toggleSidebar,
  sidebarCollapsed,
  toggleSidebarCollapse,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { userData, logout } = useContext(AuthContext);

  const roleBasedMenuItems = {
    VCM_Admin: [
      {
        label: "Dashboard",
        path: "/vcm-admin-dashboard",
        icon: "bi-speedometer2",
      },
      {
        label: "Company Management",
        path: "/vcm-admin/view-companies",
        icon: "bi-buildings",
      },
      {
        label: "VCM Admins",
        path: "/vcm-admin/view-vcm-admins",
        icon: "bi-person-plus",
      },
      {
        label: "Manage Business Categories",
        path: "/vcm-admin/manage-business-categories",
        icon: "bi-tags",
      },
      {
        label: "Manage Marketplace",
        path: "/vcm-admin/manage-marketplace",
        icon: "bi-person-plus",
      },
      {
        label: "Manage Returns",
        path: "/vcm-admin/manage-returns",
        icon: "bi-person-plus",
      },
    ],
    Company_Admin: [
      { label: "Dashboard", path: "/dashboard", icon: "bi-speedometer2" },
      { label: "User Management", path: "/users", icon: "bi-people" },

      {
        label: "Product Management",
        icon: "bi-box-seam",
        dropdown: true,
        items: [
          { label: "Categories", path: "/category", icon: "bi-tags" },
          { label: "Products", path: "/products", icon: "bi-palette" },
          {
            label: "Raw Materials",
            path: "/raw-materials",
            icon: "bi-palette",
          },
        ],
      },
      {
        label: "Merchandising",
        icon: "bi-cart4",
        dropdown: true,
        items: [
          {
            label: "Create PO",
            path: "/merchandising/po",
            icon: "bi-box-seam",
          },
          {
            label: "Raw Materials PO",
            path: "/merchandising/raw-materials-po",
            icon: "bi-box-seam",
          }
        ],
      },
      {
        label: "Warehouse",
        icon: "bi-building",
        dropdown: true,
        items: [
          {
            label: "GRN",
            icon: "bi-box-seam",
            dropdown: true,
            items: [
              {
                label: "Add GRN",
                path: "/warehouse/grn",
                icon: "bi-plus-square",
              },
              {
                label: "GRN History",
                path: "/warehouse/grn/list",
                icon: "bi-card-list",
              },
              {
                label: "Add Raw Material GRN",
                path: "/warehouse/raw-materials-grn",
                icon: "bi-plus-square",
              },
              {
                label: "Raw Material GRN History",
                path: "/warehouse/raw-materials-grn-history",
                icon: "bi-card-list",
              }
            ],
          },
          {
            label: "Issuing",
            path: "/warehouse/issuing",
            icon: "bi-box-arrow-up",
          },
          {
            label: "Stock",
            path: "/warehouse/stock",
            icon: "bi-collection",
            value: "warehouse_stock",
          },
          {
            label: "Offers",
            path: "/warehouse/offers",
            icon: "bi-percent",
            value: "warehouse_offers",
          },
          {
            label: "Allocate Stock",
            path: "/warehouse/allocate-stock/history",
            icon: "bi-arrow-up-right",
            value: "warehouse_stock_allocation",
          },
        ],
      },

      {
        label: "Finance",
        icon: "bi-currency-dollar",
        dropdown: true,
        items: [
          {
            // label: "Admin",
            // icon: "bi-person-gear",
            // dropdown: true,
            // items: [
            //   {
            label: "Add currency",
            path: "/finance/currency",
            icon: "bi-wallet",
          },
          {
            label: "Add supplier",
            path: "/finance/supplier",
            icon: "bi-people",
          },
          {
            label: "Add Tax Rates",
            path: "/accounting/tax",
            icon: "bi-cash",
          },
          //   ],
          // },
        ],
      },
      // {
      //   label: "Accounting",
      //   icon: "bi-calculator",
      //   dropdown: true,
      //   items: [{ label: "Tax", path: "/accounting/tax", icon: "bi-cash" }],
      // },
      {
        label: "Approvals",
        icon: "bi bi-patch-check me-2",
        dropdown: true,
        items: [
          {
            label: "Approve PO",
            path: "/approve-po",
            icon: "bi bi-file-check me-2",
          },
          {
            label: "Approve Raw Material PO",
            path: "/approve-po-for-raw-materials",
            icon: "bi bi-file-check me-2",
          }
        ],
      },
      // {
      //   label: "Marketing",
      //   icon: "bi-megaphone",
      //   dropdown: true,
      //   items: [
      //     {
      //       label: "Facebook Ads",
      //       path: "/marketing/facebook-ads",
      //       icon: "bi-facebook",
      //     },
      //     {
      //       label: "Facebook Settings",
      //       path: "/marketing/facebook-settings",
      //       icon: "bi-gear",
      //     },
      //   ],
      // },

      {
        label: "Sites & Locations",
        icon: "bi bi-tree",
        dropdown: true,
        items: [
          {
            label: "Warehouse Locations",
            path: "/manage-warehouse-locations",
            icon: "bi bi-geo-alt",
            value: "manage-warehouse-locations",
          },
          {
            label: "Manage Plants",
            path: "/manage-plants",
            icon: "FaBuilding",
            value: "manage-plants",
          },
          {
            label: "Manage Branches",
            path: "/manage-branches",
            icon: "bi bi-diagram-3",
            value: "manage-branches",
          },
        ],
      },

      {
        label: "Settings",
        icon: "bi bi-gear me-2",
        dropdown: true,
        items: [
          {
            label: "Profile settings",
            path: "/profile-settings",
            icon: "bi bi-person-gear me-2",
          },
          {
            label: "Company settings",
            path: "/company-settings",
            icon: "bi bi-building-gear me-2",
          },
          {
            label: "Website settings",
            path: "/website-settings",
            icon: "bi bi-globe2 me-2",
            dropdown: true,
            items: [
              {
                label: "General Settings",
                path: "/website-settings/general",
                icon: "bi-gear",
              },
              {
                label: "Add banners",
                path: "/website-settings/banners",
                icon: "bi-wallet",
              },
              {
                label: "Add footer",
                path: "/website-settings/footer",
                icon: "bi-wallet",
              },
            ],
          },
          {
            label: "Code Generation Settings",
            path: "/code-generation-settings",
            icon: "bi bi-code-slash me-2",
          },
        ],
      },
    ],
  };

  const sidebarOptionsMap = {
    dashboard: {
      label: "Dashboard",
      path: "/dashboard",
      icon: "bi-speedometer2",
    },
    category: { 
      label: "Categories", 
      path: "/category", 
      icon: "bi-tags" 
    },
    style: { 
      label: "Products", 
      path: "/products", 
      icon: "bi-palette" 
    },
    raw_materials: { 
      label: "Raw Materials", 
      path: "/raw-materials", 
      icon: "bi-box-seam" 
    },
    warehouse_grn: {
      label: "GRN",
      path: "/warehouse/grn",
      icon: "bi-box-seam",
    },
    raw_materials_grn: {
      label: "Raw Material GRN",
      path: "/warehouse/raw-materials-grn",
      icon: "bi-box-seam",
    },
    warehouse_issuing: {
      label: "Issuing",
      path: "/warehouse/issuing",
      icon: "bi-box-arrow-up",
    },
    warehouse_stock: {
      label: "Stock",
      path: "/warehouse/stock",
      icon: "bi-collection",
    },
    warehouse_offers: {
      label: "Offers",
      path: "/warehouse/offers",
      icon: "bi-percent",
    },
    warehouse_stock_allocation: {
      label: "Allocate Stock",
      path: "/warehouse/allocate-stock/history",
      icon: "bi-percent",
    },
    merchandising_po: {
      label: "Create PO",
      path: "/merchandising/po",
      icon: "bi-box-seam",
    },
    merchandising_raw_materials_po:{
      label: "Raw Materials PO",
      path: "/merchandising/raw-materials-po",
      icon: "bi-box-seam",
    },
    finance_currency: {
      label: "Add Currency",
      path: "/finance/currency",
      icon: "bi-wallet",
    },
    finance_supplier: {
      label: "Add Supplier",
      path: "/finance/supplier",
      icon: "bi-people",
    },
    accounting_tax: {
      label: "Tax Management",
      path: "/accounting/tax",
      icon: "bi-cash",
    },
    approve_po: {
      label: "Approve PO",
      path: "/approve-po",
      icon: "bi-file-check",
    },
    approve_raw_materials_po: {
      label: "Approve Raw Material PO",
      path: "/approve-po-for-raw-materials",
      icon: "bi-file-check",
    },
    settings_profile: {
      label: "Profile settings",
      path: "/settings",
      icon: "bi-person-gear",
    },
    settings_company: {
      label: "Company settings",
      path: "/company-settings",
      icon: "bi-building-gear",
    },
    settings_website: {
      label: "Website settings",
      path: "/website-settings",
      icon: "bi-globe2",
    },
    manage_plants: {
      label: "Manage Plants",
      path: "/manage-plants",
      icon: "FaBuilding",
    },
    manage_branches: {
      label: "Manage Branches",
      path: "/manage-branches",
      icon: "bi-diagram-3",
    },
    manage_warehouse_locations: {
      label: "Warehouse Locations",
      path: "/manage-warehouse-locations",
      icon: "bi-geo-alt",
    },
    marketing_facebook_ads: {
      label: "Facebook Ads",
      path: "/marketing/facebook-ads",
      icon: "bi-facebook",
    },
    settings_code_generation: {
      label: "Code Generation Settings",
      path: "/code-generation-settings",
      icon: "bi bi-code-slash me-2",
    },
  };

  const role = userData?.role || "";
  const sideBarOptions = userData?.side_bar_options || [];

  // Dashboard path mapping based on role
  const dashboardMap = {
    VCM_Admin: {
      label: "Dashboard",
      path: "/vcm-admin-dashboard",
      icon: "bi-speedometer2",
    },
    Company_Admin: {
      label: "Dashboard",
      path: "/dashboard",
      icon: "bi-speedometer2",
    },
  };

  let menus = [];
  if (role === "VCM_Admin" || role === "Company_Admin") {
    menus = roleBasedMenuItems[role] || [];
  } else if (Array.isArray(sideBarOptions) && sideBarOptions.length > 0) {
    // Use dashboardMap if available, else fallback to a generic dashboard
    const dashboardItem = dashboardMap[role] || {
      label: "Dashboard",
      path: `/dashboard`,
      icon: "bi-speedometer2",
    };

    const dropdownParents = [
      "product_management",
      "warehouse",
      "merchandising",
      "finance",
      "accounting",
      "approvals",
      "settings",
    ];

    const menuItems = [dashboardItem];

    sideBarOptions.forEach((optionValue) => {
      if (dropdownParents.includes(optionValue)) {
        const dropdown = sidebarOptionsMap[optionValue];
        if (dropdown && dropdown.dropdown) {
          const selectedSubItems = dropdown.items.filter((subItem) =>
            sideBarOptions.includes(subItem.value),
          );
          if (selectedSubItems.length > 0) {
            menuItems.push({
              ...dropdown,
              items: selectedSubItems,
            });
          }
        }
      } else {
        const regularItem = sidebarOptionsMap[optionValue];
        if (regularItem && !regularItem.dropdown) {
          const isSubItemOfDropdown = dropdownParents.some((parentKey) => {
            const parent = sidebarOptionsMap[parentKey];
            return (
              parent &&
              parent.dropdown &&
              parent.items.some((subItem) => subItem.value === optionValue)
            );
          });
          if (!isSubItemOfDropdown) {
            menuItems.push(regularItem);
          }
        }
      }
    });

    const uniqueMenuItems = [];
    const seenLabels = new Set();

    menuItems.forEach((item) => {
      if (!seenLabels.has(item.label)) {
        seenLabels.add(item.label);
        uniqueMenuItems.push(item);
      }
    });

    menus = uniqueMenuItems;
  }

  const sidebarRef = useRef(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [openNestedDropdown, setOpenNestedDropdown] = useState(null);
  const [companyLogoUrl, setCompanyLogoUrl] = useState(companyLogo);

  // Fetch company logo based on company code
  useEffect(() => {
    const fetchCompanyLogo = async () => {
      if (!userData?.company_code) {
        setCompanyLogoUrl(companyLogo);
        return;
      }

      try {
        const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";
        const response = await fetch(
          `${BASE_URL}/api/admin/companies-by-code/${userData.company_code}`
        );
        const data = await response.json();

        if (data.success && data.company && data.company.company_logo) {
          setCompanyLogoUrl(
            `${BASE_URL}/uploads/company_logos/${data.company.company_logo}`
          );
        } else {
          setCompanyLogoUrl(companyLogo);
        }
      } catch (error) {
        console.error("Error fetching company logo:", error);
        setCompanyLogoUrl(companyLogo);
      }
    };

    fetchCompanyLogo();
  }, [userData?.company_code]);

  const handleLogout = () => {
    logout();
    navigate("/");
    toggleSidebar();
  };

  const handleDropdownClick = (idx) => {
    if (sidebarCollapsed) {
      toggleSidebarCollapse();
      setTimeout(() => {
        setOpenDropdown(openDropdown === idx ? null : idx);
      }, 100);
    } else {
      setOpenDropdown(openDropdown === idx ? null : idx);
    }
  };

  const handleNestedDropdownClick = (idx, e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenNestedDropdown(openNestedDropdown === idx ? null : idx);
  };

  return (
    <>
      {/* Mobile menu button in header */}
      <Button
        variant="none"
        className="sidebar-toggle d-lg-none position-fixed"
        onClick={toggleSidebar}
        aria-label="Toggle Sidebar"
        title="Toggle Sidebar"
        style={{
          top: "10px",
          left: "10px",
          zIndex: 1040,
          fontSize: "1.4rem",
          borderRadius: "8px",
          minWidth: "40px",
          minHeight: "40px",
        }}
      >
        &#9776;
      </Button>

      <Offcanvas
        show={sidebarOpen}
        onHide={toggleSidebar}
        responsive="lg"
        placement="start"
        className={`admin-sidebar ${sidebarCollapsed ? "collapsed" : ""}`}
      >
        <div ref={sidebarRef} style={{ display: "flex", flexDirection: "column", height: "100%" }}>
          <Offcanvas.Header closeButton className="d-lg-none">
            <Offcanvas.Title>Admin Panel</Offcanvas.Title>
          </Offcanvas.Header>

          <div className="sidebar-header d-flex flex-column align-items-stretch gap-2 position-relative d-none d-lg-block" style={{ height: "60px", flexShrink: 0 }}>
            <div className="d-flex align-items-center justify-content-between w-100">
              {/* <h5 className="sidebar-title m-0">Admin Panel</h5> */}
              {role !== "VCM_Admin" && (
                <Button
                  variant="none"
                  className="sidebar-collapse-toggle"
                  onClick={toggleSidebarCollapse}
                  aria-label="Toggle Sidebar Collapse"
                  title={sidebarCollapsed ? "Expand Sidebar" : "Collapse Sidebar"}
                  style={{
                    borderRadius: "8px",
                    minWidth: "20px",
                    minHeight: "20px",
                    maxwidth: "50px",
                    maxHeight: "50px",
                  }}
                >
                  <img
                    src={companyLogoUrl}
                    alt={`${userData?.company_name || "Company"} Logo`}
                    style={{
                      height: "50px",
                      width: "auto",
                      objectFit: "contain",
                      marginLeft: "10px",
                      marginBottom: "1rem",
                    }}
                    onError={(e) => {
                      e.target.src = companyLogo;
                    }}
                  />
                 </Button>
              )}
            </div>
          </div>

          <Offcanvas.Body style={{ flex: 1, overflowY: "auto", padding: "0.75rem 0" }}>
            <Nav
              defaultActiveKey="/dashboard"
              className="flex-column sidebar-nav"
            >
              {menus.map((item, idx) => {
                if (item.dropdown) {
                  return (
                    <Nav.Item key={idx}>
                      <Nav.Link
                        onClick={() => handleDropdownClick(idx)}
                        className={`nav-link dropdown-toggle ${
                          openDropdown === idx ? "show" : ""
                        } ${sidebarCollapsed ? "collapsed" : ""}`}
                        title={sidebarCollapsed ? item.label : ""}
                      >
                        {item.icon === "FaBuilding" ? (
                          <FaBuilding className="me-2" />
                        ) : (
                          <i className={`bi ${item.icon} me-2`}></i>
                        )}
                        <span
                          className={`nav-text ${
                            sidebarCollapsed ? "collapsed" : ""
                          }`}
                        >
                          {item.label}
                        </span>
                      </Nav.Link>
                      <div
                        className={`collapse ${
                          openDropdown === idx && !sidebarCollapsed
                            ? "show"
                            : ""
                        }`}
                      >
                        {item.items.map((subItem, subIdx) =>
                          subItem.dropdown ? (
                            <Nav.Item key={subIdx}>
                              <Nav.Link
                                className={`nav-link sub-nav-link dropdown-toggle ${
                                  openNestedDropdown === subIdx ? "show" : ""
                                } ${sidebarCollapsed ? "collapsed" : ""}`}
                                onClick={(e) =>
                                  handleNestedDropdownClick(subIdx, e)
                                }
                                title={sidebarCollapsed ? subItem.label : ""}
                              >
                                {subItem.icon === "FaBuilding" ? (
                                  <FaBuilding className="me-2" />
                                ) : (
                                  <i className={`bi ${subItem.icon} me-2`}></i>
                                )}
                                <span
                                  className={`nav-text ${
                                    sidebarCollapsed ? "collapsed" : ""
                                  }`}
                                >
                                  {subItem.label}
                                </span>
                              </Nav.Link>
                              <div
                                className={`collapse ${
                                  openNestedDropdown === subIdx &&
                                  !sidebarCollapsed
                                    ? "show"
                                    : ""
                                }`}
                              >
                                {subItem.items.map((nestedItem, nestedIdx) => (
                                  <Nav.Link
                                    key={nestedIdx}
                                    as={Link}
                                    to={nestedItem.path}
                                    className={`nav-link nested-nav-link ${
                                      location.pathname === nestedItem.path
                                        ? "active"
                                        : ""
                                    } ${sidebarCollapsed ? "collapsed" : ""}`}
                                    onClick={toggleSidebar}
                                    title={
                                      sidebarCollapsed ? nestedItem.label : ""
                                    }
                                  >
                                    {nestedItem.icon === "FaBuilding" ? (
                                      <FaBuilding className="me-2" />
                                    ) : (
                                      <i
                                        className={`bi ${nestedItem.icon} me-2`}
                                      ></i>
                                    )}
                                    <span
                                      className={`nav-text ${
                                        sidebarCollapsed ? "collapsed" : ""
                                      }`}
                                    >
                                      {nestedItem.label}
                                    </span>
                                  </Nav.Link>
                                ))}
                              </div>
                            </Nav.Item>
                          ) : (
                            <Nav.Link
                              key={subIdx}
                              as={Link}
                              to={subItem.path}
                              className={`nav-link sub-nav-link ${
                                location.pathname === subItem.path
                                  ? "active"
                                  : ""
                              } ${sidebarCollapsed ? "collapsed" : ""}`}
                              onClick={toggleSidebar}
                              title={sidebarCollapsed ? subItem.label : ""}
                            >
                              {subItem.icon === "FaBuilding" ? (
                                <FaBuilding className="me-2" />
                              ) : (
                                <i className={`bi ${subItem.icon} me-2`}></i>
                              )}
                              <span
                                className={`nav-text ${
                                  sidebarCollapsed ? "collapsed" : ""
                                }`}
                              >
                                {subItem.label}
                              </span>
                            </Nav.Link>
                          ),
                        )}
                      </div>
                    </Nav.Item>
                  );
                } else {
                  return (
                    <Nav.Link
                      as={Link}
                      to={item.path}
                      key={idx}
                      className={`nav-link ${
                        location.pathname === item.path ? "active" : ""
                      } ${sidebarCollapsed ? "collapsed" : ""}`}
                      onClick={toggleSidebar}
                      title={sidebarCollapsed ? item.label : ""}
                    >
                      {item.icon === "FaBuilding" ? (
                        <FaBuilding className="me-2" />
                      ) : (
                        <i className={`bi ${item.icon} me-2`}></i>
                      )}
                      <span
                        className={`nav-text ${
                          sidebarCollapsed ? "collapsed" : ""
                        }`}
                      >
                        {item.label}
                      </span>
                    </Nav.Link>
                  );
                }
              })}
            </Nav>
          </Offcanvas.Body>

          {/* Logout Button - Fixed at Bottom */}
          <div style={{  
            padding: "1rem",
            backgroundColor: "#fff",
            // borderTop: "1px solid rgba(59, 130, 246, 0.1)",
            flexShrink: 0
          }}>
            <Nav.Link 
              onClick={handleLogout}
              className="nav-link"
            >
              <TbLogout color="#dc3545" size="1.5rem" />
              <span
                className={`nav-text text-danger ${sidebarCollapsed ? "collapsed" : ""}`}
                style={{ fontWeight: "bold" }}
              >
                Logout
              </span>
            </Nav.Link>
          </div>
        </div>
      </Offcanvas>
    </>
  );
}
